// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"38130ddc","190":"2f5c62a8","238":"38130ddc","257":"38130ddc","336":"38130ddc","393":"86d2a111","444":"86d2a111","630":"38130ddc","896":"38130ddc"}[chunkId] + ".chunk.css";
};